import React, { Component } from 'react';
import './ListaMtoProgAsis.css';
import {
  getprogmtos,
  clearErrors,
  deleteProgMto,
  postMto,
  editProgMto
} from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

export class ListaMtoProgAsis extends Component {
  constructor() {
    super();
    this.state = {
      chasis: false,
      vaccesorios: false,
      vcontroles: false,
      vgeneral: false,
      limpieza: false,
      lelectronica: false,
      pcuantitativa: false,
      selectrica: false,
      lchasis: false,
      lubricacion: false,
      prueba1: '',
      instrumento1: '',
      valor1: '',
      aprobo1: '',
      prueba2: '',
      instrumento2: '',
      valor2: '',
      aprobo2: '',
      observaciones: '',
      horainicio: '',
      horafinal: '',
      firmarecibe: '',
      cargorecibe: '',
      fecha: '',
      errors: {},
      open: false,
      opendelete: false,
      progid: ''
    };
  }

  componentDidMount() {
    this.props.getprogmtos(this.props.equipoId);
  }

  static getDerivedStateFromProps(props, state) {
    return props.UI.errors ? { errors: props.UI.errors } : null;
  }

  render() {
    const { progmtos, loadingmto } = this.props.data;

    const rows = !loadingmto
      ? progmtos
          .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
          .map((mto, index) => ({ id: index + 1, ...mto }))
      : [];

    const columns = [
      { field: 'fecha', headerName: 'Fecha', width: 150 },
      { field: 'hora', headerName: 'Hora', width: 150 },
      { field: 'duracion', headerName: 'Duración (horas)', width: 170 },
      { field: 'estado', headerName: 'Estado', width: 150 }
    ];

    return (
       <Box className="listamtoprog-container" sx={{ width: '100%' }}>
        <Box className="listamtoprog-table" sx={{ mt: 1 }}>
          {!loadingmto ? (
            <Box sx={{ width: '100%' }}>
              <Typography sx={{ fontSize: '16px', color: '#03178C', fontWeight: 600 ,textAlign: 'center', mb: 1}}>
                Mantenimientos Preventivos Programados
              </Typography>
              <DataGrid
                rows={rows}
                columns={columns}
                disableSelectionOnClick
                components={{
                  Toolbar: () => (
                    <Box p={1}>
                      <GridToolbarQuickFilter placeholder="Buscar..." />
                    </Box>
                  )
                }}
                sx={{
                  height: 500,
                  width: '100%',
                  mt: 2,
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'primary.main',
                    color: 'white'
                  }
                }}
              />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 500 }}>
              <CircularProgress size={50} color="primary" />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

ListaMtoProgAsis.propTypes = {
  postMto: PropTypes.func.isRequired,
  getprogmtos: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteProgMto: PropTypes.func.isRequired,
  editProgMto: PropTypes.func.isRequired
};

const mapActionsToProps = {
  getprogmtos,
  clearErrors,
  deleteProgMto,
  editProgMto,
  postMto
};

const mapStateToProps = (state) => ({
  data: state.data,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(ListaMtoProgAsis);